<template>
  <div class="homeBanner">
    <el-carousel trigger="click" :height="bannerHeight" :interval="6000">
      <el-carousel-item v-for="(item,index) in banner" :key="index">
        <div v-if="item.url == undefined" class="carouselList" :style="'background-image:url('+item.imgsrc+');background-size: auto '+bannerHeight+';height: '+bannerHeight+';'">
          <div class="shadow">
            <!--我是文字-->
          </div>
        </div>
        <a v-else class="carouselList" :style="'background-image:url('+item.imgsrc+');background-size: auto '+bannerHeight+';height: '+bannerHeight+';'" target="_blank" :href="item.url">
          <div class="shadow">
            <!--我是文字-->
          </div>
        </a>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  props: ['list'],
  data() {
    return {
      bannerHeight: '600px',
      banner: [{ 'imgsrc': 'https://jointat-myfamilbook.oss-cn-hangzhou.aliyuncs.com/toPDF/peng_banner1.jpg' }, { 'imgsrc': 'https://jointat-myfamilbook.oss-cn-hangzhou.aliyuncs.com/toPDF/peng_banner2.jpg', url: 'http://maker.pengzushijia.com/project/allDataBase' }, { 'imgsrc': 'https://jointat-myfamilbook.oss-cn-hangzhou.aliyuncs.com/toPDF/peng_banner3.jpg', url: 'http://maker.pengzushijia.com' }]
    }
  },
  mounted() {
    var $this = this
    var w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    if (w < 750) {
      this.bannerHeight = w / 1920 * 600 + 'px'
    } else {
      this.bannerHeight = '600px'
    }
    window.onresize = function() {
      w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      if (w < 750) {
        $this.bannerHeight = w / 1920 * 600 + 'px'
      } else {
        $this.bannerHeight = '600px'
      }
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  ////轮播样式
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }
  .carouselList{
    width: 100%;
    background-position: center center;
    display: block;
  }
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  .shadow{
    width: 100%;
    position: absolute;
    height: 40px;
    line-height: 40PX;
    color: red;
    background-color: rgba(0,0,0,.3);
    bottom: 0;
  }

</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px){
    .shadow{
      background: transparent;
    }
  }
</style>
